export const HomeBenefits = [
  {
    title: "Sencilla",
    description:
      "Completamente en línea y podrás elegir el tipo de reporte a comprar por patente.",
  },
  {
    title: "Transparente",
    description:
      "Las fuentes consultadas se especifican en cada sección del reporte. Además, podrás ver el avance durante su generación.",
  },
  {
    title: "Cómoda",
    description:
      "Recibirás todos los documentos en tu correo electrónico. Además, podrás consultarlos en la sección Mis Reportes.",
  },
];

export const UtilConst = {
  ls_referral_code: "referral_code",
  re_captcha: "re_captcha",
};

export const Google_Analitys_Categories = {
  cat_new_report: "request_new_report",
  ga_actions: {
    next: "click_next_button",
    cancel: "click_cancel_button",
    load: "load_page",
    select_payment: "select_payment_method",
    pay: "click_pay_button",
    checkout: "click_button_checkout_email",
    success_checkout: "success_checkout",
    report_id: "report_id",
  },
};
export const GaStepCancelLabel = [
  "step_general_data_canceled",
  "step_payment_method_canceled",
  "step_summary_canceled",
];
